import axios from "../utils/axios";

export function createQrPayment(payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/qr-payment/create`, payload)
        .then(res => res.data);
}


export function getQrPaymentStatus(refNo) {
    return axios.get(`${process.env.REACT_APP_API_URL}/qr-payment/status/${process.env.REACT_APP_PAYMENT_APP_NAME}/${refNo}`)
        .then(res => res.data);
}
